/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImpactType } from '../../models/impact-type';

export interface ListImpactTypes$Params {
}

export function listImpactTypes(http: HttpClient, rootUrl: string, params?: ListImpactTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImpactType>>> {
  const rb = new RequestBuilder(rootUrl, listImpactTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ImpactType>>;
    })
  );
}

listImpactTypes.PATH = '/rest/impact/listTypes';
